import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled
} from '@mui/material';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: '4px 16px',
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:last-child td': {
    borderBottom: 0,
  },
}));

const LastRateDialog = ({ open, onClose, lastRate, lastRateData }) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="md"
     
    >
      <DialogTitle sx={{ 
        backgroundColor: (theme) => theme.palette.primary.main,
        color: (theme) => theme.palette.common.white,
        padding: '10px 24px'
      }}>
        Last Rate History
      </DialogTitle>
      <DialogContent sx={{ padding: 0 }}>
        {lastRateData.length > 0 ? (
          <>
            <Typography variant="subtitle1" sx={{ 
              padding: '16px 24px 8px',
              fontWeight: 'bold',
              color: (theme) => theme.palette.text.primary
            }}>
              Current Rate: <span style={{ color: '#2e7d32' }}>{lastRate}</span>
            </Typography>
            <TableContainer component={Paper} elevation={0}>
              <Table size="small" sx={{ minWidth: 500 }}>
                <TableHead sx={{ backgroundColor: (theme) => theme.palette.grey[100] }}>
                  <TableRow>
                  <StyledTableCell sx={{ fontWeight: 'bold' }}>Party Name</StyledTableCell>
                  <StyledTableCell sx={{ fontWeight: 'bold' }}>Trn No.</StyledTableCell>
                  <StyledTableCell sx={{ fontWeight: 'bold' }}>Trn. Date</StyledTableCell>
                  <StyledTableCell sx={{ fontWeight: 'bold' }}> Bill No.</StyledTableCell>
                    <StyledTableCell sx={{ fontWeight: 'bold' }}>Item Name</StyledTableCell>
                    <StyledTableCell sx={{ fontWeight: 'bold' }} align="right">Rate</StyledTableCell>
                    <StyledTableCell sx={{ fontWeight: 'bold' }} align="right">Quantity</StyledTableCell>
                    <StyledTableCell sx={{ fontWeight: 'bold' }} align="right">Amount</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {lastRateData.map((transaction, index) => (
                    <StyledTableRow key={index} hover>
                       <StyledTableCell>{transaction.PartyName}</StyledTableCell>
                       <StyledTableCell>{transaction.TrnNo}</StyledTableCell>
                       <StyledTableCell>{transaction.TrnsDt.split('T')[0]}</StyledTableCell>
                       <StyledTableCell>{transaction.BillNo}</StyledTableCell>
                      <StyledTableCell>{transaction.ItmName}</StyledTableCell>
                      <StyledTableCell align="right">{transaction.Rate}</StyledTableCell>
                      <StyledTableCell align="right">{transaction.Quantity}</StyledTableCell>
                      <StyledTableCell align="right">{transaction.Amount}</StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        ) : (
          <Typography sx={{ padding: '24px' }}>No rate history available</Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ padding: '16px 24px' }}>
        <Button 
          onClick={onClose} 
          variant="contained"
          color="primary"
          size="small"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LastRateDialog;